import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText, BookOpen, Layers, GitBranch, ArrowLeft } from 'lucide-react';

const StatsSummaryBar = ({ conlang, conlangId, currentSection }) => {
  const navigate = useNavigate();
  
  const stats = [
    { 
      key: 'phonology',
      label: 'Phonemes', 
      value: conlang?.phoneme_count || 0, 
      icon: FileText, 
      color: 'text-secondary',
      bgColor: 'bg-secondary/20',
      link: `/conlang/${conlangId}/phonology`
    },
    { 
      key: 'lexicon',
      label: 'Words', 
      value: conlang?.word_count || 0, 
      icon: BookOpen, 
      color: 'text-tertiary',
      bgColor: 'bg-tertiary/20',
      link: `/conlang/${conlangId}/lexicon`
    },
    { 
      key: 'morphology',
      label: 'Morphology', 
      value: conlang?.morphology_rules_count || 0, 
      icon: Layers, 
      color: 'text-primary',
      bgColor: 'bg-primary/20',
      link: `/conlang/${conlangId}/morphology`
    },
    { 
      key: 'syntax',
      label: 'Syntax', 
      value: conlang?.syntax_rules_count || 0, 
      icon: GitBranch, 
      color: 'text-quaternary',
      bgColor: 'bg-quaternary/20',
      link: `/conlang/${conlangId}/syntax`
    },
  ];

  return (
    <div className="flex items-center gap-2 mb-6 pb-4 border-b border-border" data-testid="stats-summary-bar">
      {/* Back to Overview */}
      <button
        onClick={() => navigate(`/conlang/${conlangId}`)}
        className="flex items-center gap-1.5 px-3 py-1.5 rounded-md text-foreground-muted hover:text-foreground hover:bg-background-paper transition-colors text-sm"
        data-testid="back-to-overview"
      >
        <ArrowLeft className="w-4 h-4" />
        <span className="hidden sm:inline">Overview</span>
      </button>
      
      <div className="h-4 w-px bg-border mx-1" />
      
      {/* Stats Pills */}
      <div className="flex items-center gap-1.5 flex-wrap">
        {stats.map((stat) => {
          const Icon = stat.icon;
          const isActive = stat.key === currentSection;
          
          return (
            <button
              key={stat.key}
              onClick={() => navigate(stat.link)}
              className={`
                flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium transition-all
                ${isActive 
                  ? `${stat.bgColor} ${stat.color}` 
                  : 'bg-background-paper text-foreground-muted hover:text-foreground hover:bg-background-paper/80'
                }
              `}
              data-testid={`stat-pill-${stat.key}`}
            >
              <Icon className="w-3.5 h-3.5" />
              <span className="font-mono">{stat.value}</span>
              <span className="hidden sm:inline">{stat.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default StatsSummaryBar;
